const stripTrailingSlash = (url: string): string => url.replace(/\/+$/, '')

/**
 * Makes an absolute url out of a site relative path.
 * Social network crawlers (WhatsApp, Facebook, LinkedIn..) do not resolve
 * relative urls in meta tags, so `og:url`/`og:image` have to be absolute.
 */
export const absoluteUrl = (
    siteUrl?: string,
    path?: string
): string | undefined => {
    if (!siteUrl || path == null) return undefined

    if (/^https?:\/\//.test(path)) return path

    const normalizedPath = path.startsWith('/') ? path : `/${path}`

    // Keep the trailing slash only for the root path
    return normalizedPath === '/'
        ? `${stripTrailingSlash(siteUrl)}/`
        : `${stripTrailingSlash(siteUrl)}${stripTrailingSlash(normalizedPath)}`
}
